import { ReactElement } from 'react';
import type { PortalDeviceStatus } from '../api/backend-types';

export type DeviceOverviewStatus = PortalDeviceStatus;

export enum DeviceType {
  Healthdot = 'healthdot',
  ViQtor = 'viQtor',
  Unknown = 'unknown',
}
export type SupportedDeviceType = Exclude<DeviceType, DeviceType.Unknown>;

/**
 * What the patients list shows for a HealthDot, per HQS-2142. Six values, projected from
 * the nine HQS-2138 statuses; the two Interrupted variants are kept apart because they
 * lead a nurse to different corrective action.
 */
export type HealthdotDisplayStatus =
  | 'connecting'
  | 'waitingForFirstVitals'
  | 'connected'
  | 'interruptedNoVitals'
  | 'interruptedNoCommunication'
  | 'statusUnavailable';

export type NewPatientListInfo = {
  id: number;
  hospitalPatientId: string;
  patientName?: string;
  clinicalUnitName: string;
  clinicalUnitGroupName: string;
  startDate?: Date;
  deviceStatus: DeviceOverviewStatus;
  // HealthDot only: the HQS-2142 status, which the viQtor vocabulary cannot express.
  healthdotStatus?: HealthdotDisplayStatus;
  deviceType: DeviceType;
  batteryLevel?: number;
};

export type ClinicalUnit = {
  id: string;
  name: string;
  location?: string;
};

export type Cohort = {
  id: string;
  name: string;
  clinicalUnitId: string;
  isDefault: boolean;
};

export enum ScannerType {
  Manual = 1,
  Camera = 2,
  Handheld = 3,
}

export type ScannerPostfix = 'NONE' | 'ENTER';

export type PairingConfiguration = {
  patientIdFormat: string;
  barcodeType: string;
  patientIdBarcodeFormat?: string;
  barcodeScannerPostfix: ScannerPostfix;
  deviceBarcodeFormats: string[];
  supportedDeviceTypes: SupportedDeviceType[];
};

export type ErrorDialogContent = {
  title?: string | ReactElement;
  message: string | ReactElement;
  redirectToHome?: boolean;
  redirectToLogin?: boolean;
};
